var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChevronForward = function SvgChevronForward(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.492 5.468a.5.5 0 0 1 .707.023l6.25 6.667a.5.5 0 0 1 0 .684l-6.25 6.666a.5.5 0 0 1-.73-.684L16.4 12.5l-5.93-6.325a.5.5 0 0 1 .023-.707",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.199 5.491-.365.342zm-.707-.023-.342-.364zm6.957 6.69-.365.342zm0 .684.364.342zm-6.25 6.666.364.342zm-.707.023-.342.365zm-.023-.707.365.342zM16.4 12.5l.364-.342a.5.5 0 0 1 0 .684zm-5.93-6.325-.364.342zm.365-.342-.684-.73a1 1 0 0 1 1.413.046zm6.25 6.667-6.25-6.667.73-.684 6.25 6.667zm0 0 .73-.684a1 1 0 0 1 0 1.368zm-6.25 6.666 6.25-6.666.73.684-6.25 6.666zm0 0 .73.684a1 1 0 0 1-1.414.046zm0 0-.684.73a1 1 0 0 1-.046-1.414zm5.93-6.324-5.93 6.324-.73-.684 5.93-6.324zm-5.93-7.009 5.93 6.325-.73.684-5.93-6.325zm0 0-.73.684a1 1 0 0 1 .046-1.413z"
  })));
};
export default SvgChevronForward;